<template>
  <div>
    <div class="row">
      <div class="mx-auto col-md-12">
        <div class="card p-3 mb-3">
          <div class="card-body">
                <b-card
                  class="mb-2"
                  header="Dados Responsável Atual"
                  header-tag="header">
                <b-row>
                  <b-col class="col-6">
                    <p><strong>Nome:</strong> {{familiaAtual.nome_completo}}</p>
                  </b-col>
                  <b-col>
                    <p><strong>CPF:</strong> {{familiaAtual.cpf_requerente}}</p>
                  </b-col>
                  <b-col>
                    <p><strong>Data Nascimento:</strong> {{formatDate(familiaAtual.data_nascimento)}}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="col-6">
                    <p><strong>Nome da mãe:</strong> {{familiaAtual.nome_mae}}</p>
                  </b-col>
                  <b-col>
                    <p><strong>Sexo:</strong> {{formatarSexo(familiaAtual.sexo)}}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="col-6">
                    <p><strong>Tipo Documento:</strong> {{formatarTipo(familiaAtual.tipo_documento)}}</p>
                  </b-col>
                  <b-col>
                    <p><strong>Número Documento:</strong> {{familiaAtual.numero_documento}}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="col-6">
                    <p><strong>Órgão Emissor:</strong> {{familiaAtual.orgao_emissor}}</p>
                  </b-col>
                  <b-col>
                    <p><strong>UF:</strong> {{familiaAtual.uf_orgao_emissor}}</p>
                  </b-col>
                  <b-col>
                    <p><strong>Data Emissão:</strong> {{formatDate(familiaAtual.data_emissao)}}</p>
                  </b-col>
                 </b-row>
                 <b-row>
                  <b-col class="col-6">
                    <p v-if="familiaAtual.tipo_documento == 3"><strong>Validade Documento:</strong> {{formatDate(familiaAtual.data_validade)}}</p>
                  </b-col>
                  <b-col>
                    <p v-if="familiaAtual.tipo_documento == 3"><strong>País Emissão:</strong> {{familiaAtual.pais_emissao}}</p>
                  </b-col>
                </b-row>
                  <b-row>
                    <b-col class="col-6">
                      <p v-if="familiaAtual.tipo_documento == 4"><strong>Série Documento:</strong> {{familiaAtual.serie_documento}}</p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="col-6">
                      <p><strong>CEP:</strong> {{familiaAtual.cep_endereco}}</p>
                    </b-col>
                    <b-col>
                      <p><strong>Número:</strong> {{familiaAtual.numero_logradouro}}</p>
                    </b-col>
                    <b-col>
                      <p><strong>Tipo Logradouro:</strong> {{familiaAtual.tipo_logradouro}}</p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="col-6">
                      <p><strong>Logradouro:</strong> {{familiaAtual.endereco}}</p>
                    </b-col>
                    <b-col>
                      <p><strong>Bairro:</strong> {{familiaAtual.bairro}}</p>
                    </b-col>
                    <b-col>
                      <p><strong>Complemento:</strong> {{familiaAtual.complemento_logradouro}}</p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="col-6">
                      <b-card-text><strong>Situação: </strong>
                          <b-badge v-if='ind_ativo == "A"' variant="success">Ativo</b-badge>
                          <b-badge v-else-if='ind_ativo == "I"' variant="danger">Inativo</b-badge>
                          <b-badge v-else-if='ind_ativo == "P"' variant="warning">Aguardando Confirmação</b-badge>
                      </b-card-text>
                    </b-col>
                  </b-row>
                </b-card> 
            <b-card
                class="mb-2"
                :header="header_novo"
                header-tag="header">
                <b-form inline>
                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="nome_completo">CPF</label>
                        <the-mask
                            id="cpf"
                            name="cpf"
                            pattern="[0-9\.\-]*"
                            inputmode="numeric"
                            v-model="$v.familiasTemp.cpf_requerente.$model"
                            placeholder="000.000.000-00"
                            mask="###.###.###-##"
                            type="text"
                            :masked="false"
                            :class="`form-control` + ($v.familiasTemp.cpf_requerente.$error ? ` is-invalid` : ``)"
                        ></the-mask>
                    </div>

                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="nome_completo">Nome</label>
                        <b-form-input
                            id="nome_completo"
                            type="text"
                            placeholder="Nome"
                            v-model="$v.familiasTemp.nome_completo.$model"
                            required
                            :class="`w-100` + ($v.familiasTemp.nome_completo.$error ? ` is-invalid` : ``)"
                            @keyup.native="removeAcentos($event)"
                        ></b-form-input>
                    </div>
                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="data_nascimento">Data Nascimento</label>
                        <b-form-input
                            id="data_nascimento"
                            v-model="$v.familiasTemp.data_nascimento.$model"
                            type="date"
                            required
                            :class="($v.familiasTemp.data_nascimento.$error ? ` is-invalid` : ``)"
                        ></b-form-input>
                        <div class="error mt-2 d-block ml-2" v-if="!$v.familiasTemp.data_nascimento.idadeMinima"><small>Idade mínima para o beneficiário é de 16 anos.</small></div>
                    </div>
                    
                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="nome_mae">Nome da mãe</label>
                        <b-form-input
                            id="nome_mae"
                            v-model="$v.familiasTemp.nome_mae.$model"
                            type="text"
                            placeholder="Nome"
                            required
                            :class="`w-100` + ($v.familiasTemp.nome_mae.$error ? ` is-invalid` : ``)"
                            @keyup.native="removeAcentos($event)"
                        ></b-form-input>
                    </div>

                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="sexo">Sexo</label>
                        <b-form-radio-group
                            id="sexo"
                            v-model="$v.familiasTemp.sexo.$model"
                            :options="tipoSexo"
                            required
                            :class="`w-100` + ($v.familiasTemp.sexo.$error ? ` is-invalid` : ``)"
                        >
                        </b-form-radio-group>
                    </div>

                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="tipo_documento">Tipo Documento</label>
                        <b-form-select
                            id="tipo_documento"
                            v-model="$v.familiasTemp.tipo_documento.$model"
                            :options="tipos"
                            :class="`mb-2 mr-sm-1 mb-sm-0 col-md-3` + ($v.familiasTemp.tipo_documento.$error ? ` is-invalid` : ``)"
                            @change.native="changeTipoDocumento"
                        ></b-form-select>

                        <label class="mr-sm-1 col-md-3 p-0" for="numero_documento">Número documento</label>
                        <the-mask
                            id="numero_documento"
                            pattern="[0-9\.\-]*"
                            inputmode="numeric"
                            mask="####################"
                            placeholder="Somente números"
                            :masked="false"
                            v-model="$v.familiasTemp.numero_documento.$model"
                            type="text"
                            required
                            :class="`w-100 form-control` + ($v.familiasTemp.numero_documento.$error ? ` is-invalid` : ``)"
                        ></the-mask>
                    </div>

                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="orgao_emissor">Órgão emissor</label>
                        <b-form-input
                            id="orgao_emissor"
                            v-model="$v.familiasTemp.orgao_emissor.$model"
                            type="text"
                            required
                            placeholder="Somente letras"
                            :class="`col-md-2 mb-2` + ($v.familiasTemp.orgao_emissor.$error ? ` is-invalid` : ``)"
                            @keypress.native="isLetter($event)"
                            @keyup.native="removeAcentos($event)"
                            @change.native="changeOrgao()"
                        ></b-form-input>

                        <label class="mr-sm-1 col-md-1 p-0" for="uf_orgao_emissor">UF</label>
                        <b-form-select
                            id="uf_orgao_emissor"
                            v-model="$v.familiasTemp.uf_orgao_emissor.$model"
                            :class="`mb-2 mr-sm-1 mb-sm-0` + ($v.familiasTemp.uf_orgao_emissor.$error ? ` is-invalid` : ``)"
                            :options="estados"
                        ></b-form-select>

                        <label class="mr-sm-1 col-md-2 p-0" for="data_emissao">Data emissão</label>
                        <b-form-input
                            id="data_emissao"
                            v-model="$v.familiasTemp.data_emissao.$model"
                            type="date"
                            required
                            :class="`w-100` + ($v.familiasTemp.data_emissao.$error ? ` is-invalid` : ``)"
                        ></b-form-input><br>
                    </div>

                    <div class="error text-right w-100 mt-0" v-if="$v.familiasTemp.data_emissao.$error">
                      <div v-if="!$v.familiasTemp.data_emissao.menorQueHoje">
                        <small>Data de emissão não pode ser maior que a data de hoje.</small>
                      </div>
                    </div>

                    <div class="p-0 mb-3 col-12 d-md-flex" v-if="familiasTemp.tipo_documento == 3 || familiasTemp.tipo_documento == 4">

                        <label class="mr-sm-1 col-md-2 p-0" for="data_validade" v-if="familiasTemp.tipo_documento == 3">Validade documento</label>
                        <b-form-input
                            id="data_validade"
                            v-model="familiasTemp.data_validade"
                            type="date"
                            required
                            :class="`col-md-2 mb-2 w-100` + ($v.familiasTemp.data_validade.$error ? ` is-invalid` : ``)"
                            :disabled="familiasTemp.tipo_documento != 3"
                            v-if="familiasTemp.tipo_documento == 3"
                        ></b-form-input>

                        <label class="mr-sm-1 col-md-2 p-0" for="pais_emissao" v-if="familiasTemp.tipo_documento == 3">País Emissão</label>
                        <b-form-select
                            id="pais_emissao"
                            v-model="familiasTemp.pais_emissao"
                            :options="paises"
                            :class="`mb-2 mr-sm-1 mb-sm-0 col-md-2` + ($v.familiasTemp.pais_emissao.$error ? ` is-invalid` : ``)"
                            :disabled="familiasTemp.tipo_documento != 3"
                            v-if="familiasTemp.tipo_documento == 3"
                        ></b-form-select>

                        <label class="mr-sm-1 col-md-2 p-0" for="serie_documento" v-if="familiasTemp.tipo_documento == 4">Série documento</label>
                        <b-form-input
                            id="serie_documento"
                            v-model="familiasTemp.serie_documento"
                            type="text"
                            :class="`w-100` + ($v.familiasTemp.serie_documento.$error ? ` is-invalid` : ``)"
                            :disabled="familiasTemp.tipo_documento != 4"
                            v-if="familiasTemp.tipo_documento == 4"
                        ></b-form-input>
                    </div>

                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="cep_endereco">Cep</label>
                        <the-mask
                            id="cep_endereco"
                            pattern="[0-9\.\-]*"
                            inputmode="numeric"
                            mask="#####-###"
                            :masked="false"
                            v-model="$v.familiasTemp.cep_endereco.$model"
                            type="text"
                            required
                            :class="`col-md-2 mb-2 form-control` + ($v.familiasTemp.cep_endereco.$error ? ` is-invalid` : ``)"
                            @input="buscaCep"
                        ></the-mask>

                        <label class="mr-sm-1 col-md-2 p-0" for="numero_logradouro">Número</label>
                        <the-mask
                            id="numero_logradouro"
                            pattern="[0-9\.\-]*"
                            inputmode="numeric"
                            mask="######"
                            :masked="false"
                            v-model="$v.familiasTemp.numero_logradouro.$model"
                            type="text"
                            required
                            :class="`col-md-2 form-control` + ($v.familiasTemp.numero_logradouro.$error ? ` is-invalid` : ``)"
                        ></the-mask>
                        <label class="mr-sm-1 col-md-2 p-0" for="bairro">Bairro</label>
                        <b-form-input
                            id="bairro"
                            v-model="$v.familiasTemp.bairro.$model"
                            type="text"
                            required
                            class="w-100"
                            :class="`w-100` + ($v.familiasTemp.bairro.$error ? ` is-invalid` : ``)"
                            disabled
                        ></b-form-input>
                    </div>

                    <div class="p-0 mb-3 col-12 d-md-flex">
                        <label class="mr-sm-1 col-md-2 p-0" for="tipo_logradouro">Tipo Logradouro</label>
                        <b-form-input
                            id="tipo_logradouro"
                            v-model="$v.familiasTemp.tipo_logradouro.$model"
                            type="text"
                            required
                            :class="`col-md-1 mb-2` + ($v.familiasTemp.tipo_logradouro.$error ? ` is-invalid` : ``)"
                            disabled
                        ></b-form-input>

                        <label class="mr-sm-1 col-md-2 p-0" for="endereco">Logradouro</label>
                        <b-form-input
                            id="endereco"
                            v-model="$v.familiasTemp.endereco.$model"
                            type="text"
                            required
                            :class="`col-md-3 mb-2` + ($v.familiasTemp.endereco.$error ? ` is-invalid` : ``)"
                            disabled
                        ></b-form-input>

                        <label class="mr-sm-1 col-md-2 p-0" for="complemento_logradouro">Complementos</label>
                        <b-form-input
                            id="complemento_logradouro"
                            v-model="familiasTemp.complemento_logradouro"
                            type="text"
                            required
                            class="w-100"
                            maxlength="30"
                            @keyup.native="removeAcentos($event)"
                        ></b-form-input>
                    </div>
                </b-form>
                <template v-slot:footer>
                    <b-row>
                        <b-col class="text-left">   
                            <b-button                                               
                                variant="outline-secondary"                   
                                @click.prevent="back" 
                                title="Voltar">
                                    <font-awesome-icon                                                                      
                                        :icon="['fas','arrow-left']"
                                        title="Voltar"
                                        class="mr-1"
                                    />
                                    Voltar
                            </b-button>
                        </b-col> 
                        <b-col class="text-right" v-if="$route.params.origem === 'cidadao'">                    
                            <b-button                                               
                                variant="success"                   
                                @click.prevent="solicitar"
                                title="Solicitar alteração">
                                  <font-awesome-icon                                                                      
                                        :icon="['fas','check']"
                                        title="Voltar"
                                        class="mr-1"
                                    />
                                    Solicitar alteração
                            </b-button>                                
                        </b-col>
                        <b-col class="text-right" v-if="$route.params.origem === 'admin'">                    
                            <b-button                                               
                                variant="success"                   
                                @click.prevent="confirmar"
                                title="Confirmar alteração">
                                  <font-awesome-icon                                                                      
                                        :icon="['fas','check']"
                                        title="Voltar"
                                        class="mr-1"
                                    />
                                    Confirmar alteração
                            </b-button>                                
                        </b-col>                            
                    </b-row>
                </template>
              </b-card>
          </div>
        </div>
      </div>
    </div>
    <b-modal header-bg-variant="warning" v-model="modalShow" title="ALERTA" ok-only centered>
        <p>{{ msgModal }}</p>
    </b-modal>
    <b-modal :title= tituloSolicitacao v-model="modalShowSolcitacao" ok-only centered>
      <p>Solicitação de substituição de responsável familiar por outro membro da família recebida.</p>
      <p class="text-danger"><strong>IMPORTANTE!</strong></p>
      <p>Para concluir, é necessário que o Sr(a). beneficiário(a) compareça <strong>presencialmente</strong> a uma das unidades listadas no site do auxílio, 
          com <strong>documento de identificação com foto, até o dia 25/03/2022</strong>.</p>
      <p>Lista de unidades: <b-link href="https://prefeitura.pbh.gov.br/smasac/suass/equipamentos/dras" target="_blank">
        https://prefeitura.pbh.gov.br/smasac/suass/equipamentos/dras</b-link>
      </p>
    </b-modal>
    <b-modal title="Alteração" v-model="modalShowImprimir" no-close-on-esc no-close-on-backdrop hide-header-close centered>
      <p>Responsável familiar alterado com sucesso.</p>
      <template #modal-footer>
        <div class="w-100 text-center">
          <b-button 
              variant="success"                   
              @click.prevent="gerarComprovante">
              <font-awesome-icon                                                                      
                    :icon="['fas','file-download']"
                    class="mr-1"
                />
            Gerar Comprovante
          </b-button>
          </div>
        </template>
    </b-modal>
  </div>
</template>

<script>
import {
  required,
  requiredIf
} from "vuelidate/lib/validators";

import { TheMask } from "vue-the-mask";
import {paises, cnvTipoLogradouro, formatDate} from '../../../helpers';
import FamiliasTemp from '../../../models/FamiliasTemp'
import { validaCPF } from "../../../validations/index";


export default {
  components: {
    TheMask
  },
  data() {
    return {
      titulo:'',
      cpf:'',
      nome:'',
      ind_ativo:'',
      header_novo:'Inserir dados novo Responsável',
      familiaAtual: new FamiliasTemp(),
      estados: ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'],
      tipos: [
        { text: 'Selecione', value: null },
        { text: 'RG - Registro Geral', value: 1 },
        { text: 'CNH - Carteira Nacional de Habilitação', value: 2 },
        { text: 'Passaporte', value: 3 },
        { text: 'CTPS - Carteira de Trabalho e Previdência Social', value: 4 },
        { text: 'CIE - Carteira de Identidade de Estrangeiros', value: 5 },
        { text: 'RNE - Registro Nacional de Estrangeiros', value: 6 }
      ],
      paises: paises,
      familiasTemp: new FamiliasTemp(),
      modalShow: false,
      modalShowSolcitacao:false,
      modalShowImprimir:false,
      tituloSolicitacao:'',
      msgModal: "",
      achouCep: true,
      dados: {
        tipo_documento: null,
        uf_orgao_emissor: null
      },
      tipoSexo: [
          { text: 'Masculino', value: 'M' },
          { text: 'Feminino', value: 'F' },
          { text: 'Outros', value: 'O' }
      ],
    };
  },
  validations: {
    familiasTemp: {
      cpf_requerente: {
        isCpf: (cpf_requerente) => validaCPF(cpf_requerente),
        required
      },
      nome_completo: {
        required
      },
      data_nascimento: {
        required,
        idadeMinima: (function (value) {                    
          var dtNascimento = new Date(value);
          dtNascimento.setFullYear(dtNascimento.getFullYear() + 16);

          return dtNascimento < new Date();
        }),
      },
      nome_mae: {
        required
      },
      sexo: {
        required
      },
      tipo_documento: {
        required
      },
      numero_documento: {
        required
      },
      orgao_emissor: {
        required
      },
      uf_orgao_emissor: {
        required
      },
      data_emissao: {
        required,
        menorQueHoje: (function (value) {                    
          var data = new Date(value);
          return data < new Date();
        }),
      },
      data_validade: {
        required: requiredIf(function() {
          return this.familiasTemp.tipo_documento == 3;
        })
      },
      pais_emissao: {
        required: requiredIf(function() {
          return this.familiasTemp.tipo_documento == 3;
        })
      },
      serie_documento: {
        required: requiredIf(function() {
          return this.familiasTemp.tipo_documento == 4;
        })
      },
      cep_endereco: {
        required
      },
      numero_logradouro: {
        required
      },
      tipo_logradouro: {
        required
      },
      bairro: {
        required
      },
      endereco: {
        required
      }
    }
  },
  computed: {
    http() {
      return this.$store.getters.http;
    },
  },
  methods: {
    formatarSexo(sexo){
      if(sexo === 'M'){
        return 'Masculino'
      }else if(sexo === 'F'){
        return 'Feminino'
      }else{
        return 'Outros'
      }
    },

    formatarTipo(tipo){
      switch (tipo) {
          case 1:
            return 'RG - Registro Geral';
          case 2:
            return 'CNH - Carteira Nacional de Habilitação';
          case 3:
            return 'Passaporte';
          case 4:
            return 'CTPS - Carteira de Trabalho e Previdência Social';
          case 5:
            return 'CIE - Carteira de Identidade de Estrangeiros';
          case 6:
            return 'RNE - Registro Nacional de Estrangeiros';
          default:
            return "";
      }
    },
    formatDate,
    back() {
        if(this.$route.params.origem === 'cidadao'){
          this.$router.push({ name: 'home'});
        } else {
          this.$router.push({ name: 'beneficiarios'});
        } 
    },
    changeOrgao() {
      if(/^[a-zA-Z\s]*$/.test(this.familiasTemp.orgao_emissor)) {
        return true; // Match with regex 
      }
      else this.familiasTemp.orgao_emissor = '';
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if(/^[a-zA-Z\s]*$/.test(char)) {
        return true; // Match with regex 
      }
      else e.preventDefault(); // If not match, don't add to input text
    },
    changeTipoDocumento() {
      setTimeout(() => { 
        if( this.familiasTemp.tipo_documento != 3 ) {
          this.familiasTemp.data_validade = '';
          this.familiasTemp.pais_emissao = null;
        }

        if( this.familiasTemp.tipo_documento != 4 ) {
          this.familiasTemp.serie_documento = '';
        }
      }, 1);
    },
    removeAcentos(e) {
      var texto = e.target.value;
      var semAcento = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
      e.target.value = semAcento;
    },
    buscaCep() {
      if( this.familiasTemp.cep_endereco.length == 8) {
        let query = this.familiasTemp.cep_endereco;
        let url = `buscar-endereco?filtro=${query}`;
        this.$api.get(url)
        .then(response => {                    
            if(response.status === 201){
                var endereco = response.data.dados  
                this.familiasTemp.tipo_logradouro = endereco.tipo_logradouro ? cnvTipoLogradouro(endereco.tipo_logradouro) : null;
                this.familiasTemp.endereco = endereco.nome_logradouro;
                this.familiasTemp.bairro   = endereco.bairro_popular;             
            }
        })
        .catch(error => {  
            if(error.response.data){
                this.modalShow = true;
                this.msgModal = error.response.data.message;                     
            } 
        });
      }
    },

    solicitar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$bvModal.msgBoxConfirm('Deseja realmente solicitar a alteração do responsável familiar atual: '+this.familiaAtual.nome_completo+' para o novo responsável familiar: '+this.familiasTemp.nome_completo+' ?', {
            title: 'Solicitação',
            centered: true,
            okTitle: 'Sim',
            cancelTitle: 'Não',
            showCancelButton: false,
        }).then(value => {
            if(value) {
              this.$api.post(`novo-responsavel`, this.familiasTemp)
                .then(response => {                    
                    if(response){                                      
                        this.formAlterado = false; 
                        this.modalShowSolcitacao = true;
                        this.tituloSolicitacao = 'Informação'
                        this.ind_ativo = 'P';                                    
                    } 
                })
                .catch(error => {                               
                    if(error.response.data){                        
                        this.$helpers.showToast(this, 'Erro', error.response.data.message,'danger');                        
                    } 
              }); 
            }
        }).catch(err => {
            console.log(err);
        });
      }
      
    },

    confirmar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$bvModal.msgBoxConfirm('Deseja realmente confirmar a alteração do responsável familiar atual: '+this.familiaAtual.nome_completo+' para o novo responsável familiar: '+this.familiasTemp.nome_completo+' ?', {
            title: 'Confirmação',
            centered: true,
            okTitle: 'Sim',
            cancelTitle: 'Não',
            showCancelButton: false,
            footerClass: "p-2 border-top-0 mb-3"
        }).then(value => {
            if(value) {
              this.$api.put(`${this.familiasTemp.familia_id}/alterar-responsavel`, this.familiasTemp)
                .then(response => {                    
                    if( !response.data.erro ) {
                        this.modalShowImprimir = true;
                    }
                })
                .catch(error => {                               
                    if(error.response.data){                        
                      this.$helpers.showToast(this, 'Erro', error.response.data.message,'danger');                        
                    } 
              }); 
            }
        }).catch(err => {
            console.log(err);
        });
      }
      
    },

    gerarComprovante(){
      this.$api.get(`comprovante-alterar-responsavel/${this.familiasTemp.familia_id}/${this.familiasTemp.cpf_requerente}`, {responseType: 'blob'})
        .then(response => {  
            this.$helpers.downloadFile(response.data,'comprovante_alteracao_rf.pdf'); 
            this.$router.push({ name: 'beneficiarios'});              
        })
        .catch( () => {                                            
            this.$helpers.showToast(this,'Erro', 'Erro na geração do comprovante', 'danger');                                            
        }); 
    },

    async load() {
      if(this.$route.params.origem === 'admin'){
          this.header_novo = 'Dados novo Responsável';
          const id = this.$route.params.dados.id;
          const result = await this.$api.get(`familias/${id}`);
          this.familiaAtual = result.data.familia;
          this.ind_ativo = this.$route.params.dados.ind_ativo;
            this.$nextTick(() => {
              this.$api.get(`${id}/dados-novo-responsavel`)
              .then(response => {
                if(response.data.dados){
                  this.familiasTemp = response.data.dados;
                } else {
                  this.familiasTemp = new FamiliasTemp();
                  this.familiasTemp.familia_id = this.$route.params.dados.id;
                }
              })
              .catch(error => {   
                  if(error.response.data){                        
                      this.$helpers.showToast(this,'Erro', error.response.data.message, 'danger');                        
                  }                                                                          
              })
            }); 
  
      } else {
        this.familiaAtual = this.$route.params.dados;
        this.ind_ativo = this.$route.params.dados.ind_ativo;
        this.familiasTemp.familia_id = this.$route.params.dados.id;
      }
    }
    
  },
  mounted() {
      this.load();
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
}
#turno {
  text-transform: uppercase;
}
</style>
